export default "__VITE_ASSET__Dy4S9By9__"